'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.Signup = void 0;
var transport_1 = require("../../transport");
var Signup = /** @class */ (function () {
    function Signup() {
    }
    Signup.prototype.getCurrencies = function () {
        return transport_1.transport.request('signup/currencies');
    };
    Signup.prototype.registrationTypes = function () {
        return transport_1.transport.request('signup/registrationTypes');
    };
    Signup.prototype.getRegDDLists = function () {
        return transport_1.transport.request('signup/getRegDDLists');
    };
    Signup.prototype.checkEmail = function (params) {
        return transport_1.transport.request('signup/checkEmail', params);
    };
    Signup.prototype.getOccupations = function (params) {
        return transport_1.transport.request('signup/occupations', params);
    };
    Signup.prototype.getOccupationsByRegulation = function (params) {
        return transport_1.transport.request('signup/occupationsByRegulation', params);
    };
    Signup.prototype.getNationalities = function () {
        return transport_1.transport.request('signup/getNationalities');
    };
    Signup.prototype.checkUsername = function (params) {
        return transport_1.transport.request('signup/checkUsername', params);
    };
    Signup.prototype.getSubdivisions = function (params) {
        return transport_1.transport.request('signup/getSubdivisions', params);
    };
    Signup.prototype.getIndustries = function () {
        return transport_1.transport.request('signup/getIndustries');
    };
    Signup.prototype.addressFinder = function (params) {
        return transport_1.transport.request('signup/addressFinder', params);
    };
    Signup.prototype.addressFinderMetadata = function (params) {
        return transport_1.transport.request('signup/addressFinderMetadata', params);
    };
    Signup.prototype.getPepSourceOfWealth = function () {
        return transport_1.transport.request('signup/getPepSourceOfWealth');
    };
    Signup.prototype.getPepSourceOfFunds = function () {
        return transport_1.transport.request('signup/getPepSourceOfFunds');
    };
    Signup.prototype.getPepCategories = function () {
        return transport_1.transport.request('signup/getPepCategories');
    };
    return Signup;
}());
exports.Signup = Signup;
